import { createFileRoute } from "@tanstack/react-router";
import { Shell } from "@/components/control-tower/Layout";
import { ActivityFeed } from "@/components/control-tower/ActivityFeed";
import { useDashboardStats } from "@/lib/api/useDashboardStats";
import { useFilteredBuildings } from "@/lib/inventory-scope";

export const Route = createFileRoute("/activity")({
  component: ActivityPage,
});

function ActivityPage() {
  const state = useDashboardStats();
  const buildings = useFilteredBuildings(
    state.status === "ok" ? state.buildings : [],
  );

  return (
    <Shell
      title="Tapahtumaloki"
      subtitle="Käyttäjien ja Kairosin muutokset · suodata työn ja sen mukaan, mitä tapahtuma koskee"
    >
      <ActivityFeed buildings={buildings} />
    </Shell>
  );
}
